module.exports = __webpack_public_path__ + "img/payment-logos-snapscan.02527bb0.png";